var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M11.7 3.69a.331.331 0 0 1 .6 0l2.417 5.194a.33.33 0 0 0 .26.188l5.731.673c.28.033.392.376.186.566l-4.237 3.883a.33.33 0 0 0-.1.304l1.125 5.61a.33.33 0 0 1-.485.35l-5.036-2.794a.33.33 0 0 0-.322 0l-5.036 2.793a.33.33 0 0 1-.485-.349l1.125-5.61a.33.33 0 0 0-.1-.304l-4.237-3.883a.327.327 0 0 1 .186-.566l5.73-.673a.33.33 0 0 0 .261-.188z"
  })));
};
export default SvgStarFilled;